import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from '@benzinga/themed-icons';
import { CreditCardIcon } from '@benzinga/user-ui';

interface CreditCardProps {
  card: {
    brand: string;
    expMonth: number;
    expYear: number;
    last4: string;
    uuid: string;
  };
  setSelectedCard?: (card: any) => void;
}

const CreditCard = ({ card, setSelectedCard }: CreditCardProps) => {
  const handleClick = () => {
    if (!setSelectedCard) return;
    setSelectedCard(card);
  };
  return (
    <div
      className={`flex flex-row items-start gap-2 py-2 ${setSelectedCard ? 'cursor-pointer hover:bg-slate-300' : ''}`}
      key={card.last4}
      onClick={handleClick}
    >
      <div className="pt-1">
        <CreditCardIcon type={card.brand} />
      </div>
      <div className="flex flex-col">
        {card.brand} ending in {card.last4}
        <span className="text-xs">
          Expires: {card.expMonth}/{card.expYear}
        </span>
      </div>
    </div>
  );
};

export const CreditCardBlock = ({ creditCards, selectedCard, setSelectedCard }) => {
  const [showCardOptions, setShowCardOptions] = useState(false);
  return (
    <div className="bg-bzgrey-100/80 rounded-md p-2 my-2 relative">
      <div>Payment</div>
      {selectedCard && (
        <div className="flex flex-row items-start gap-2 pt-2 w-full">
          <CreditCard card={selectedCard} />
          {creditCards.length > 1 && (
            <div
              className="pt-4 ml-auto p-2 text-xl cursor-pointer"
              onClick={() => setShowCardOptions(!showCardOptions)}
            >
              {showCardOptions ? <ChevronUp /> : <ChevronDown />}
            </div>
          )}
        </div>
      )}
      {showCardOptions && (
        <div className="absolute -bottom-14 bg-bzgrey-100 left-0 right-0 p-2">
          {creditCards.length > 1 &&
            creditCards
              .filter(card => card.uuid !== selectedCard.uuid)
              .map(card => {
                return <CreditCard card={card} key={card.uuid} setSelectedCard={setSelectedCard} />;
              })}
        </div>
      )}
      {creditCards.length === 0 && (
        <div>No credit card on file. Please close this modal, add the card in and try again.</div>
      )}
    </div>
  );
};
